import script from "./BalStack.vue?vue&type=script&lang=ts"
export * from "./BalStack.vue?vue&type=script&lang=ts"

import "./BalStack.vue?vue&type=style&index=0&id=022c58f0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-022c58f0"]])

export default __exports__